import { render, staticRenderFns } from "./mf_changes.vue?vue&type=template&id=671b2258&scoped=true&lang=html&"
import script from "./mf_changes.vue?vue&type=script&lang=js&"
export * from "./mf_changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b2258",
  null
  
)

export default component.exports